import React, { useEffect, useState } from "react";
import { Box, Button, Stack, Typography } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import CrudPopup from "../commonComponent/CrudPopup";
import { useDispatch, useSelector } from "react-redux";
import {
  handleAddBrand,
  handleDeleteBrand,
  handleEditBrand,
  handleGetBrandList,
} from "../../../appStore/actions/ArkchatGroup/action";
import editIcon from "../../../assets/images/editTopic.svg";

import { crossIcon, crossIconDiv } from "../../../assets/commonFunction";
const classes = {
  drawerBody: {
    minWidth: "31.25rem",
    maxWidth: "31.25rem",
    display: "flex",
    justifyContent: "space-between",
    flexDirection: "column",
    height: "100%",
  },
  header: {
    backgroundColor: "#EAEAEA",
    color: "#000000",
    padding: "7px 8px",
  },
  iconDiv: crossIconDiv,
  iconn: crossIcon,
};
const BrandDrawer = ({
  setBrandDrawerOpen,
  editBrandData,
  setEditBrandData,
}) => {
  const brandList = useSelector(
    (state) => state?.arkchatgroup?.brandDataList?.data
  );
  const [isOpen, setOpen] = useState(false);
  const [isEditBrandOpen, setEditBrandOpen] = useState(false);
  const [isDeleteConfirmationOpen, setDeleteConfirmationOpen] = useState(false);
  const [addBrandData, setAddBrandData] = useState({
    name: "",
    website: "",
  });
  const dispatch = useDispatch();
  const handleChange = (e) => {
    const { name, value } = e.target;
    setAddBrandData({
      ...addBrandData,
      [name]: value,
    });
  };
  const handleEditBtnClicked = (data) => {
    setEditBrandData(data);
    setAddBrandData({
      name: data?.name,
      website: data?.website,
    });
    setEditBrandOpen(true);
  };
  useEffect(() => {
    dispatch(handleGetBrandList());
  }, [dispatch]);

  const handleSaveBrand = (e) => {
    e.preventDefault();
    dispatch(handleAddBrand(addBrandData)).then((res) => {
      dispatch(handleGetBrandList());
      setOpen(false);
    });
  };
  const handleUpdateBrand = (e) => {
    e.preventDefault();
    dispatch(handleEditBrand(addBrandData, editBrandData?.id)).then((res) => {
      dispatch(handleGetBrandList());
      setAddBrandData({
        name: "",
        website: "",
      });
      setEditBrandOpen(false);
    });
  };
  const handleDelete = () => {
    setEditBrandOpen(false);
    setDeleteConfirmationOpen(true);
  };
  const handleDeleteConfirm = () => {
    dispatch(handleDeleteBrand(editBrandData?.id)).then((res) => {
      dispatch(handleGetBrandList());
      setDeleteConfirmationOpen(false);
    });
  };
  return (
    <React.Fragment>
      <CrudPopup
        inputLable1={"Brand name"}
        inputLable2={"Website"}
        isBrand={true}
        open={isOpen}
        closePopup={setOpen}
        title={"Add Brand"}
        addbtnLable={"Save"}
        handleChange={handleChange}
        handleSave={handleSaveBrand}
        value={addBrandData}
        setAddData={setAddBrandData}
      />
      <CrudPopup
        inputLable1={"Brand name"}
        inputLable2={"Website"}
        isBrand={true}
        open={isEditBrandOpen}
        closePopup={setEditBrandOpen}
        title={"Edit Brand"}
        addbtnLable={"Save"}
        isEdit={true}
        handleChange={handleChange}
        handleSave={handleUpdateBrand}
        value={addBrandData}
        handleDelete={handleDelete}
        setAddData={setAddBrandData}
      />
      <CrudPopup
        open={isDeleteConfirmationOpen}
        closePopup={setDeleteConfirmationOpen}
        title={"Edit Brand"}
        isConfirmation={true}
        handleDeleteConfirm={handleDeleteConfirm}
        setAddData={setAddBrandData}
      />
      <Box position={"relative"} sx={classes.drawerBody}>
        <Stack>
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="space-between"
            sx={classes.header}
          >
            <Stack
              onClick={() => {
                setBrandDrawerOpen(false);
              }}
              direction="row"
              alignItems="center"
              spacing={2}
            >
              <Typography sx={classes.iconDiv}>
                <CloseIcon sx={classes.iconn} />
              </Typography>
              <Typography fontSize={"1rem"} variant="h6" fontWeight={400}>
                Brand name
              </Typography>
            </Stack>
          </Stack>
          <Box mt={"0.5rem"}>
            {brandList?.length > 0 &&
              brandList?.map((item) => (
                <Box
                  sx={{ cursor: "pointer" }}
                  padding={"0.2rem 0rem"}
                  width={"90%"}
                  margin={"auto"}
                  display={"flex"}
                  justifyContent={"space-between"}
                  key={item?.id + "brandDrawer"}
                >
                  <Box
                    onClick={() => {
                      setEditBrandData(item);
                      setBrandDrawerOpen(false);
                    }}
                  >
                    <Typography variant="h6" fontSize={"1rem"} fontWeight={400}>
                      {" "}
                      {item?.name}
                    </Typography>
                  </Box>
                  <Box
                    onClick={() => handleEditBtnClicked(item)}
                    sx={{
                      cursor: "pointer",
                      height: "1rem",
                      width: "1rem",
                    }}
                  >
                    <img
                      style={{ width: "100%", height: "100%" }}
                      src={editIcon}
                      alt="editIcon"
                    />
                  </Box>
                </Box>
              ))}
          </Box>
          <Box left={"20%"} width={"60%"} position={"absolute"} bottom={"1rem"}>
            <Button
              sx={{
                width: "100%",
                textTransform: "none",
                borderRadius: "2px",
                border: "1px solid #DB0011",
                backgroundColor: "#DB0011",
                color: "white",
                ":hover": {
                  border: "1px solid #DB0011",
                  backgroundColor: "#DB0011",
                  color: "white",
                },
              }}
              variant="outlined"
              onClick={() => setOpen(true)}
            >
              Add Brand
            </Button>
          </Box>
        </Stack>
      </Box>
    </React.Fragment>
  );
};

export default BrandDrawer;
